import { Link } from 'react-router-dom';
import styles from './PageAbout.module.css'
import Button from '../../components/Button/Button';

function PageAbout() {
  return (
    <div className={styles.PageAbout}>
      <div className={styles.CodeAblazeTitle}>
        <h1>About Us</h1>
      </div>
      <div className={styles.ContentDiv}>
        <div className={styles.DescriptionDiv}>
          At CodeAblaze, we are passionate about empowering the next generation of innovators through our coding program. Our experienced instructors are dedicated to providing a supportive learning environment where students can thrive and unleash their creativity. We are currently holding our program at several local elementary and middle schools. Get in touch with us to learn more!
          <div className={styles.Spacing} />
          <Link to="/contact" className={styles.ContactButton}>
            <Button text={"Contact"} />
          </Link>
        </div>
      </div>
    </div>
  );
}

export default PageAbout;
